import { IApiRequestConfig } from '../api.types';

export interface IGetInvoicesParams {
  page?: number;
  limit?: number;
}

export const getInvoicesApi = (params: IGetInvoicesParams = {}): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getInvoices',
  action: 'invoices',
  method: 'get',
  v2: true,
  params,
});

export const getInvoiceApi = (invoiceId: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getInvoice',
  action: `invoices/${encodeURIComponent(invoiceId)}`,
  method: 'get',
  v2: true,
});
